{
  "general": {
    "tools": "Tools"
  },
  "header": {
    "nav.docs": "Documentation",
    "nav.specification": "Specification"
  },
  "toolsWalletAddress": {
    "heading.message": "Wallet address",
    "tooltip.ariaLabel": "Why connect your wallet?",
    "tooltip.message": "Connecting your wallet allows us to save your custom layouts, link them to you as the original author, and verify ownership for future updates.",
    "tooltip.message2": "It also enables Web Monetization on your behalf by embedding your wallet address into your web page automatically.",
    "errors.fieldRequired": "This field is required",
    "errors.connectionError": "You have not connected your wallet address yet.",
    "status.connect": "If you're connecting your wallet address for the first time, you'll start with the default layout. You can then customize and save your layout as needed.",
    "status.noSavedProfiles.banner": "This is the default banner style. Customize it to make it your own.",
    "status.noSavedProfiles.widget": "This is the default widget style. Customize it to make it your own.",
    "status.noSavedProfiles.offerwall": "This is the default offerwall style. Customize it to make it your own.",
    "status.noSavedProfiles.paywall": "This is the default paywall style. Customize it to make it your own.",
    "status.profilesFetched.banner": "We've loaded your layouts. Feel free to keep customizing your banner to fit your style.",
    "status.profilesFetched.widget": "We've loaded your layouts. Feel free to keep customizing your widget to fit your style.",
    "status.profilesFetched.offerwall": "We've loaded your layouts. Feel free to keep customizing your offerwall experience to fit your style.",
    "status.profilesFetched.paywall": "We've loaded your layout. Feel free to keep customizing your pay per article to fit your style.",
    "button.loadingLabel": "Connecting...",
    "button.submitLabel": "Continue",
    "button.disconnectAriaLabel": "Disconnect wallet"
  },
  "paywall": {
    "title": "Pay per Article",
    "description_1": "Pay Per Article lets visitors unlock gated content with a one-time payment.",
    "description_2": "It provides a clean, customizable interface to configure pricing, and choose how locked content is revealed.",
    "section.settings.title": "Settings",
    "inputgroup.price.title": "Price",
    "inputgroup.price.desc": "Set the one-time payment amount visitors pay to unlock this page’s gated content.",
    "input.price.label": "Amount",
    "input.price.hint": "Charged in your wallet's currency ({{currency}})",
    "inputgroup.placement.title": "Paywall placement",
    "inputgroup.placement.desc": "Choose how much of the page the paywall covers, and when it appears to the visitor.",
    "input.coverage.label": "Coverage on the page",
    "input.coverage.hint": "How much of the screen the paywall takes when it appears.",
    "input.delay.label": "Show paywall after",
    "input.delay.hint": "Set to 0 to show the paywall immediately on page load.",
    "input.delay.suffix": "seconds",
    "input.title.label": "",
    "input.title.hint": "Short and direct works best.",
    "input.message.label": "Subtitle",
    "input.message.hint": "Explain the value in one sentence.",
    "input.message.placeholder": "Unlock the full article with a one-time payment — no subscription, no account.",
    "input.payButton.label": "Pay button label",
    "input.payButton.placeholder": "Unlock article"
  }
}
